import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { GoodsRecordsModal } from "./GoodsRecordsModal";
import { OccupyNumModal } from "./OccupyNumModal";

export function InventoryStatistic() {
    return (
        <>
            <PageHeader />
            <DataBox />
            <OccupyNumModal />
            <GoodsRecordsModal />
        </>
    )
}